<div class="h-full min-h-0 overflow-hidden">
  <lib-header
    [isToggleVisible]="true"
    [isToggled]="isSidebarCollapsed()"
    [toggleTooltip]="sidebarToggleTooltip()"
    (toggleChange)="onToggleChange($event)"
  >
    <ng-container #rightActions>
      <div class="flex gap-4">
        <p-select
          class="w-full md:w-56"
          data-testid="org-switcher"
          [options]="organizations()"
          [ngModel]="selectedOrganizationId()"
          optionLabel="name"
          optionValue="id"
          placeholder="Select an organization"
          size="small"
          (onChange)="onOrganizationChange($event.value)"
        />
        @if (userModel) {
          <lib-account-menu
            [menuItems]="accountMenuItems()"
            [userName]="userModel.fullName"
            [userRole]="userModel.roleTranslationKey | translate"
          />
        }
      </div>
    </ng-container>
  </lib-header>
  <lib-split-view [isCollapsed]="isSidebarCollapsed()">
    <ng-container splitViewLeft>
      <lib-navigation [items]="navigationMenuItems()"></lib-navigation>
    </ng-container>

    <ng-container splitViewRight>
      <router-outlet></router-outlet>
    </ng-container>
  </lib-split-view>
</div>
